import { ArrowDownwardTwoTone, ArrowUpwardTwoTone, Print } from '@mui/icons-material';
import { Box, Button, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { FC, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { PrintAction } from './PrintActions';




export const ComponentToPrint: FC<{ componentRef?: React.MutableRefObject<null>, data: any[], name: string, phone: string }> = ({ componentRef, data, name, phone }) => {

 return (
  <Box p={4} ref={componentRef} mt={0}>
   <Box>
    <TableContainer component={Box} >
     <Table sx={{ width: "100%" }} aria-label="simple table">
      <TableHead>
       <TableRow>
        <TableCell align="left" sx={{ fontWeight: 700, color: "green", border: 0.5, borderTopRightRadius: 8, width: 150, fontSize: 14, p: 1 }}>Agent's name</TableCell>
        <TableCell align="left" sx={{ fontWeight: 700, color: "green", border: 0.5, borderTopRightRadius: 8, width: 70, fontSize: 14, p: 1 }}>Container ID</TableCell>
       </TableRow>
      </TableHead>
      <TableBody sx={{ border: 0.5, borderColor: "green" }}>
       <TableRow
        sx={{ '&:last-child td, &:last-child th': { border: "solid 1px green" } }}
       >
        <TableCell align="left" width={150} sx={{ fontSize: 14, p: 1 }}>
         Arbi
         {/* {name ? name : "-"} */}
        </TableCell>
        <TableCell align="left" width={85} sx={{ fontSize: 14, p: 1 }}>
         {phone ? phone : "Farmer"}
        </TableCell>
       </TableRow>
      </TableBody>
     </Table>
    </TableContainer>
    <Stack direction="column" alignItems="start" spacing={2}>
     <Stack direction="row" alignItems="flex-start" spacing={2} width="100%">
     <Stack direction="column" alignItems="flex-start" spacing={2}>
      <Typography variant="body2" fontWeight="bold" >
       <Stack alignItems="center" direction="row" spacing={2}>
        <ArrowDownwardTwoTone fontSize="small" sx={{ color: 'green' }} />
        <span>
         IN
        </span>
       </Stack>
      </Typography>
      <TableContainer component={Paper}>
       <Table>
        <TableHead>
         <TableRow>
          <TableCell>Quantity</TableCell>
          <TableCell>Facture</TableCell>
          <TableCell>Container</TableCell>
          <TableCell>Product</TableCell>
          <TableCell>Date</TableCell>
          <TableCell>Action</TableCell>
         </TableRow>
        </TableHead>
        {(data || []).filter((item: any) => item.type === "in").map((action: any, index: number) => (
         <PrintAction action={action} key={index} />
        ))}
       </Table>
      </TableContainer>
     </Stack>
     <Stack direction="column" alignItems="flex-start" spacing={2}>
      <Stack alignItems="center" direction="row" spacing={2}>
       <ArrowUpwardTwoTone fontSize="small" sx={{ color: 'red' }} />
       <span>
        OUT
       </span>
      </Stack>
      <TableContainer component={Paper}>
       <Table>
        <TableHead>
         <TableRow>
          <TableCell>Quantity</TableCell>
          <TableCell>Facture</TableCell>
          <TableCell>Container</TableCell>
          <TableCell>Product</TableCell>
          <TableCell>Date</TableCell>
          <TableCell>Action</TableCell>
         </TableRow>
        </TableHead>
        {(data || []).filter((item: any) => item.type === "out").map((action: any, index: number) => (
         <PrintAction action={action} key={index}  />
        ))}
       </Table>
      </TableContainer>
     </Stack>
    </Stack>
    </Stack>
   </Box>
  </Box>
 )
}

export const ComponentToPrintContainer: FC<{ headerInfo: { name: string, phone: string }, data: any[] }> = ({ headerInfo, data }) => {
 const date = new Date();
 const new_date = date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear() + "    |     " + date.getHours() + ":" + date.getMinutes();

 const componentRef = useRef(null);
 const handlePrint = useReactToPrint({
  content: () => componentRef.current,
  onAfterPrint: () => {
   alert(`Facture for  [${headerInfo ? headerInfo.name : ""}] printed successfully`);
  },
  onPrintError: () => {
   alert("Verify your facture")
  },
  documentTitle: `facture_for_${headerInfo ? headerInfo.name : ""}_${new_date}`,
 });

 return (
  <Box>
   <Box sx={{ display: "none" }}>
    <ComponentToPrint componentRef={componentRef} data={data} name={headerInfo.name} phone={headerInfo.phone} />
   </Box>
   <Button startIcon={<Print />} onClick={() => { handlePrint() }}>
    Print
   </Button>
  </Box>
 );
};